import { authorizeIfLoggedIn } from "../../../components/Auth/AuthorizedApiClientBase";
import { WealthMappingClient } from "./generated/WealthMappingClient";

export const WealthMappingClientFactory = () => {
    const client = new WealthMappingClient(process.env.WEALTH_MAPPING_BACKEND_URL);
    authorizeIfLoggedIn(client);

    return client;
}